import { FC, ReactElement } from 'react';
import { BorderedStatusIcon, cn, TStatus } from '@fe-learner-common';

type ErrorMessageProps = {
  className?: string;
  action?: ReactElement;
  status: TStatus;
  texts: {
    title: string;
    description: string;
  };
};

export const FeedbackMessage: FC<ErrorMessageProps> = ({
  className,
  texts,
  action,
  status,
}) => {
  return (
    <div
      className={cn(
        'lf:flex lf:flex-col lf:items-center lf:justify-center lf:px-6 lf:py-[100px]',
        className,
      )}
    >
      <BorderedStatusIcon status={status} />
      <h2 className="lf:pt-4 lf:text-headline-md">{texts.title}</h2>
      <p className="lf:whitespace-pre-line lf:pt-2 lf:text-center lf:text-body-md lf:text-neutral-500">
        {texts.description}
      </p>
      {action && <div className="lf:pt-4">{action}</div>}
    </div>
  );
};
